<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-left: 15px;">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>库存维护</el-breadcrumb-item>
            <el-breadcrumb-item>库存管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card style="height: 100%;">
            <el-row :gutter="0">
                <el-col :span="10">
                    <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
                        style="width:300px " @clear="getKucunList" @change="getKucunList">
                        <el-button slot="append" icon="el-icon-search" @click="getKucunList"></el-button>

                    </el-input>
                    <el-button type="primary" @click="rukuAdd" v-if="xiugai_type == 1">入库</el-button>
                    <el-button type="primary" @click="chukuAdd" v-if="xiugai_type == 1">出库</el-button>
                </el-col>
                <el-col :span="8">
                    <el-button type="primary" @click="get_product_add" v-if="false">出库清单</el-button>
                </el-col>
                <el-col :span="6" style="text-align: right;">
                    <el-button type="primary" @click="handleExport()">导出电子表格</el-button>
                    <el-button type="primary" @click="handleExportAll()">导出所有页电子表格</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="0" class="el_row_two">
                <el-col :span="24">
                    <el-table :data="productList" style="width: 100%" border stripe id="report">
                        <el-table-column type="expand">
                            <template slot-scope="scope">
                                <el-table :data="scope.row.list" stripe>
                                    <el-table-column width="80" label="明细序号"> <template slot-scope="scope">{{ scope.$index
                                    }}</template>
                                    </el-table-column>
                                    <el-table-column prop="pro_uid" label="商品序号" width="200"> </el-table-column>
                                    <el-table-column prop="pro_name" label="商品名称" width="200"> </el-table-column>
                                    <el-table-column label="商品类别" width="300">
                                        <template slot-scope="scope">{{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{
                                            scope.row.leixing03 }}:{{ scope.row.leixing04 }}</template>
                                    </el-table-column>
                                    <el-table-column prop="pro_count" label="商品数量" show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop="pro_kuwei" label="库位号" show-overflow-tooltip>
                                    </el-table-column>
                                </el-table>
                            </template>

                        </el-table-column>
                        <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
                        <el-table-column prop="uid" label="序号"></el-table-column>
                        <el-table-column prop="qiye_bianhao" label="门店编号"></el-table-column>
                        <el-table-column prop="qiye_name" label="门店名称"></el-table-column>
                        <el-table-column prop="pro_bianhao" label=" 编号"></el-table-column>
                        <el-table-column prop="pro_name" label="名称"></el-table-column>
                        <el-table-column label="类型">
                            <template v-slot="scope">
                                {{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{ scope.row.leixing03 }}:{{
                scope.row.leixing04 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="pro_xinghao" label="型号" width="120"></el-table-column>
                        <el-table-column prop="pro_price_chengben" label="最低成交价" width="80"></el-table-column>
                        <el-table-column prop="add_time" label="加入时间" width="190"></el-table-column>
                        <el-table-column label="实时库存数">
                            <template v-slot="scope">
                                <span style="text-align: center;width: 200px; color: red;"> {{ scope.row.kucun_pro_count
                -
                scope.row.kucun_pro_count_suoding }}</span>
                                <el-button v-if="false"
                                    @click="kucun_kucun_add(scope.row.uid, scope.row.pro_bianhao, scope.row.pro_name, scope.row.pro_type, scope.row.leixing01, scope.row.leixing02, scope.row.leixing03, scope.row.leixing04, scope.row.count)"
                                    type="primary" plain style="margin-left: 20px;">添加</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-table :data="productListAll" style="width: 100%;display: none;" border stripe id="reportAll">

                        <el-table-column prop="uid" label="序号"></el-table-column>
                        <el-table-column prop="qiye_bianhao" label="门店编号"></el-table-column>
                        <el-table-column prop="qiye_name" label="门店名称"></el-table-column>
                        <el-table-column prop="pro_bianhao" label=" 编号"></el-table-column>
                        <el-table-column prop="pro_name" label="名称"></el-table-column>
                        <el-table-column label="类型">
                            <template v-slot="scope">
                                {{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{ scope.row.leixing03 }}:{{
                scope.row.leixing04 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="pro_xinghao" label="型号" width="120"></el-table-column>
                        <el-table-column prop="pro_price_chengben" label="最低成交价" width="80"></el-table-column>
                        <el-table-column prop="add_time" label="加入时间" width="190"></el-table-column>
                        <el-table-column label="实时库存数">
                            <template v-slot="scope">
                                <span style="text-align: center;width: 200px; color: red;"> {{ scope.row.kucun_pro_count
                -
                scope.row.kucun_pro_count_suoding }}</span>
                                <el-button v-if="false"
                                    @click="kucun_kucun_add(scope.row.uid, scope.row.pro_bianhao, scope.row.pro_name, scope.row.pro_type, scope.row.leixing01, scope.row.leixing02, scope.row.leixing03, scope.row.leixing04, scope.row.count)"
                                    type="primary" plain style="margin-left: 20px;">添加</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>

            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
                <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
            </el-pagination>

            <el-dialog title="入库" :visible.sync="rukuDialogVisible" width="90%" height="80%" @close="rukuDoalogClosed">
                <rukuAdd @ruku_addClose="ruku_addClose" ref="rukuAddRef" @flushKucunPage="flushKucunPage"> </rukuAdd>
            </el-dialog>
            <el-dialog title="出库" :visible.sync="chukuDialogVisible" width="90%" height="80%"
                @close="chukuDoalogClosed">
                <chukuAdd @chuku_addClose="chuku_addClose" ref="chukuAddRef" @flushKucunPage="flushKucunPage">
                </chukuAdd>
            </el-dialog>

        </el-card>
    </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from './config/validator'
import exportExcel from './config/exportExcel'
// import rukuDo from './module/ruku_do.vue'
// import chukuDo from './module/chuku_do.vue'
import rukuAdd from './module/ruku_add.vue'
import chukuAdd from './module/chuku_add.vue'
export default {
    components: {
        // rukuDo: rukuDo,
        // chukuDo: chukuDo,
        rukuAdd: rukuAdd,
        chukuAdd: chukuAdd
    },
    props: ['xiugai_type', 'qiye_uid', 'show_type'], // xiugai_type 1  操作  2 显示 qiye_uid qiye_uid  企业uid ，显示模式show_type 全部显示，只显示制定企业uid部分
    data() {
        return {
            rukuDialogVisible: false,
            chukuDialogVisible: false,
            kucunDialogVisible: false,
            kucundan_bianhao: '',
            kucunAddData: [],
            kucunAddData_proUid: [],
            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list_more',
                C_table_name: 'kucun_car_list_more',
                query: '',
                pageNum: 1,
                pageSize: 10,
                CI_canshu01: this.show_type,
                CI_canshu02: 0
            },
            queryInfoAll: {
                C_type: 'get_list_more',
                C_table_name: 'kucun_car_list_more',
                query: '',
                pageNum: 1,
                pageSize: 1000000,
                CI_canshu01: this.show_type,
                CI_canshu02: 0
            },
            productList: [],
            productListAll: [],
            //  recordCount: 0,
            total: 0,
            addForm: {
                C_type: 'product_add',
                pro_bianhao: '',
                pro_xinghao: '',
                pro_price_shichang: 0,
                pro_price_huiyuan: 0,
                pro_price_pifa: 0,
                pro_price_gaoji: 0,
                pro_name: '',
                pro_chandi: '',
                pro_xilie: '',
                pro_type: '',
                pro_level: 1,
                pro_memo: ''
            },

            // 表单规则项
            addFormRules: {

            },

            editFormRules: {

            }
        };
    },
    created() {
        this.getKucunList()
    },
    methods: {
        handleExport() {
            exportExcel('report', '导出.xlsx')
        },
        handleExportAll() {
            exportExcel('reportAll', '所有库存信息.xlsx')
        },
        flushKucunPage(t) {
            console.log(9999, 9999)
            this.getKucunList()
        },
        rukuAdd() {
            this.rukuDialogVisible = true
        },
        chukuAdd() {
            this.chukuDialogVisible = true
        },
        kucunAdd() {
            this.kucunDialogVisible = true
        },
        rukuDoalogClosed() {
            this.$refs.rukuAddRef.closeRuku()
        },

        chukuDoalogClosed() {
            this.$refs.chukuAddRef.closeChuku()
        },
        ruku_addClose() {
            this.rukuDialogVisible = false
        },
        chuku_addClose() {
            this.chukuDialogVisible = false
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        kucun_kucun_add(proUid, proBianhao, proName, proType, leixing01, leixing02, leixing03, leixing04, proCount) {
            // 分析商品uid 重复的 直接累加
            // 借助 kucunAddData_proUid 找到下标
            const xiabiao = this.kucunAddData_proUid.indexOf(proUid) // 找到下标返回下标，没有找到返回-1
            this.getKucunList()
            if (xiabiao !== -1) {
                this.kucunAddData[xiabiao].proCount += proCount
                return
            }
            var dataAdd = {
                proUid: proUid,
                proBianhao: proBianhao,
                proName: proName,
                proType: proType,
                leixing01: leixing01,
                leixing02: leixing02,
                leixing03: leixing03,
                leixing04: leixing04,
                proCount: proCount
            }
            this.kucunAddData.push(dataAdd)
            this.kucunAddData_proUid.push(proUid)
        },

        async getKucunList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            })
            this.productList = JSON.parse(res.data)[0].dataList
            console.log(1912, this.productList)
            const { data: res02 } = await this.$http.get('get_api', {
                params: this.queryInfoAll
            })
            this.productListAll = JSON.parse(res02.data)[0].dataList
            this.total = JSON.parse(res.data)[0].total;
            // console.log(this.total)
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getKucunList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getKucunList();
        }
    }
}
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}
</style>
